export default __webpack_public_path__ + "static/media/home2.2a84d284.jpg";